import * as types from './types'

export const showMessage = ({ commit }, message) => {
  commit(types.SET_STATUS_MESSAGE, { message: message })
}
